import { render } from "./AboutBanner.vue?vue&type=template&id=7616ef05&scoped=true"
import script from "./AboutBanner.vue?vue&type=script&lang=js"
export * from "./AboutBanner.vue?vue&type=script&lang=js"

import "./AboutBanner.vue?vue&type=style&index=0&id=7616ef05&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7616ef05"

export default script